'use strict';

var ajax = require('../../ajax'),
    util = require('../../util'),
    tealium = require('../../../../../int_tealium/cartridge/js/tealium/tealium');
    



/**
 * @private
 * @function
 * @description Binds events to the order confirmation page
 */
function initializeEvents() {
    var url = Urls.checkoutSubscription;
    var orderId = $(".order-number .value").text();
    if (SitePreferences.showSmsSignUpCheckboxOnCheckout) {
        if ($("[name='sms-sign-up']").length > 0 && orderId && orderId.length > 0) {
            url = util.appendParamToURL(url, 'orderId', orderId);
            ajax.getJson({
                url: url,
                callback: function (data) {
                    //@todo
                    //Error scenarios handled on order confirmation page store
                    if(!data.success){
                        $(".order-confirmation-details .order-information").after('<div class=\"sms-vibes-error\"><span>!</span><p>'+Resources.CHECKOUT_SMS_VIBES_ERROR_MSG+'</p><button class="btn-ds btn btn-link text-link-1 float-sm-right" onclick="smsOptModal.open()">'+Resources.CHECKOUT_SMS_VIBES_REENTER_TXT+'</button></div>');
                    }                    
                }
            });
        }
    }

    if (SitePreferences.enableAttentiveSmsSignUpCheckboxOnCheckout) {
        var attnUrl = Urls.checkoutSubscriptionAttn;
        if ($("[name='sms-sign-up']").length > 0 && orderId && orderId.length > 0) {
            attnUrl = util.appendParamToURL(attnUrl, 'orderId', orderId);
            ajax.getJson({
                url: attnUrl,
                callback: function (data) {}
            });
        }
    }

    if($('.order-detail-section').length){
        $('.order-detail-section').find('.view-more-link').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.order-detail-section').find('.expanded-section').toggle();
            $(this).closest('.order-detail-section').find('.ecoship-shipping').toggle();
            if (!$(this).hasClass('opened')) {
                $(this).addClass('opened').text('View Less');
                $(this).closest('.order-detail-section').addClass('expanded-order').find('.total').addClass('total-expanded');
            } else {
                $(this).removeClass('opened').text('View Details');
                $(this).closest('.order-detail-section').removeClass('expanded-order').find('.total').removeClass('total-expanded');
            }
        });
    }
    //AZ-2969 Tealium analytics for returns and echanges
    $('div.qa-content div.answer a').on('click', function (e) {
        var eventData = {
         "tealium_event": "link",
         "event_name": "return_exchanges_interaction",
         "return_exchanges_interaction_selection": "Track My Order",
         "return_exchanges_event_location" : "Order Confirmation"
         };
        tealium.triggerEvent(eventData);
     });
     
     $('#RegistrationForm .largebutton').on('click', function () {
        var $registrationForm = $('#RegistrationForm');
        var $passwordContainer = $registrationForm.find('div.password');
        var $passwordConfirmContainer = $registrationForm.find('div.passwordconfirm');

        if ($passwordContainer.find('span.label-text').hasClass('exit-form')) { return false; }
        if ($passwordConfirmContainer.length > 0 && $passwordConfirmContainer.find('span.error:visible').length > 0) { return false; }
     });
}

exports.init = function () {
    initializeEvents();
};
